import { Bento, BentoItem } from "./Bento";
import type { BentoItemProps } from "./Bento";
import { cn } from "./utils";

export interface EsqueletoProps {
  className?: string;
  /** Texto para lectores de pantalla; el esqueleto visual es decorativo. */
  etiqueta?: string;
}

/** Indicador de carga (§6.8: muestra esqueleto si la carga tarda). */
export function Esqueleto({ className, etiqueta = "Cargando" }: EsqueletoProps) {
  return (
    <div
      role="status"
      aria-label={etiqueta}
      className={cn(
        "animate-pulse rounded-control bg-texto-secundario/15 motion-reduce:animate-none",
        className,
      )}
    />
  );
}

export function EsqueletoTarjeta() { return <div className="rounded-card border border-borde/60 bg-superficie p-4"><Esqueleto className="h-4 w-24" /><Esqueleto className="mt-4 h-8 w-2/3" /></div>; }
export interface PlantillaEsqueletoBento { columnas: BentoItemProps["columnas"]; /** Líneas de contenido de la tarjeta (por defecto 1). */ lineas?: number }

/** Esqueleto con la misma rejilla y spans que el Bento real, para evitar saltos de layout al cargar. */
export function EsqueletoBento({ plantilla = [{ columnas: 6 }, { columnas: 6 }, { columnas: 6 }, { columnas: 6 }], etiqueta = "Cargando" }: { plantilla?: PlantillaEsqueletoBento[]; etiqueta?: string }) {
  return (
    <Bento aria-busy="true">
      {plantilla.map(({ columnas, lineas = 1 }, indice) => (
        <BentoItem key={indice} columnas={columnas}>
          <div className="h-full rounded-card border border-borde/60 bg-superficie p-4">
            <Esqueleto className="h-5 w-24" etiqueta={indice === 0 ? etiqueta : "Cargando"} />
            {Array.from({ length: lineas }, (_, linea) => <Esqueleto key={linea} className="mt-4 h-12" />)}
          </div>
        </BentoItem>
      ))}
    </Bento>
  );
}
